var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 1.33301C4.32465 1.33301 1.33398 4.32367 1.33398 7.99967C1.33398 11.6757 4.32465 14.6663 8.00065 14.6663C8.97798 14.6663 9.97465 14.419 10.962 13.9303L10.372 12.735C9.56932 13.1317 8.77132 13.333 8.00065 13.333C5.05998 13.333 2.66732 10.9403 2.66732 7.99967C2.66732 5.05901 5.05998 2.66634 8.00065 2.66634C10.9413 2.66634 13.334 5.05901 13.334 7.99967V8.66634C13.334 9.12767 13.1253 9.99967 12.334 9.99967C11.4033 9.99967 11.338 8.78701 11.334 8.66634V5.33301H10.0007V5.34967C9.42683 4.90897 8.72417 4.6689 8.00065 4.66634C6.16265 4.66634 4.66732 6.16167 4.66732 7.99967C4.66732 9.83768 6.16265 11.333 8.00065 11.333C8.96732 11.333 9.83265 10.9123 10.442 10.2523C10.7913 10.8457 11.3807 11.333 12.334 11.333C13.8493 11.333 14.6673 9.95901 14.6673 8.66634V7.99967C14.6673 4.32367 11.6767 1.33301 8.00065 1.33301ZM8.00065 9.99967C6.89798 9.99967 6.00065 9.10234 6.00065 7.99967C6.00065 6.89701 6.89798 5.99967 8.00065 5.99967C9.10332 5.99967 10.0007 6.89701 10.0007 7.99967C10.0007 9.10234 9.10332 9.99967 8.00065 9.99967Z",
    fill: "#767A7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAt);
export default __webpack_public_path__ + "static/media/icon-at.60486b1ce00cd2db52b8588949addea7.svg";
export { ForwardRef as ReactComponent };